import { createFileRoute } from "@tanstack/react-router"

import { DataQualityCheckPage } from "~/components/ingestion-cockpit/data-quality/DataQualityCheckPage"

export const Route = createFileRoute("/_auth/ingestion-cockpit/_layout/data-quality/$checkId")({
  component: RouteComponent,
})

function RouteComponent() {
  const { checkId } = Route.useParams()
  return <DataQualityCheckPage checkId={checkId} />
}
